(() => {
  // Sofortiges Feedback beim Antippen von Shop Pay / PayPal / Google Pay / Apple Pay,
  // da sich deren externes Zahlungsfenster teils erst nach 1-3 Sekunden oeffnet.
  //
  // Wie lange das im Einzelfall dauert, laesst sich von hier aus nicht vorab wissen
  // (interne Shopify-Komponente, kein oeffentliches "Fenster ist jetzt offen"-Ereignis).
  // Deshalb reagieren wir dynamisch statt eine feste Wartezeit zu raten:
  //   - Sobald das Browserfenster den Fokus verliert (window "blur"), ist bei PayPal/
  //     Google Pay in aller Regel das externe Fenster/Popup tatsaechlich aufgegangen.
  //   - Apple Pay oeffnet die native iOS-Zahlungsuebersicht innerhalb der Seite (kein
  //     Fokuswechsel), dafuer greift als Sicherheitsnetz ein fixes Timeout.

  const CONTAINER_SELECTOR = '.dynamic-checkout__content';
  const SAFETY_TIMEOUT_MS = 6000;
  const BLUR_HIDE_DELAY_MS = 300;

  let activeOverlay = null;
  let hideTimer = null;

  const onBlur = () => {
    setTimeout(hideOverlay, BLUR_HIDE_DELAY_MS);
  };

  function hideOverlay() {
    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }
    window.removeEventListener('blur', onBlur);
    if (activeOverlay) {
      activeOverlay.remove();
      activeOverlay = null;
    }
  }

  function showOverlay(container) {
    hideOverlay();

    if (getComputedStyle(container).position === 'static') {
      container.style.position = 'relative';
    }

    const overlay = document.createElement('div');
    overlay.className = 'wallet-click-feedback';
    overlay.innerHTML = '<span class="wallet-click-feedback__spinner"></span>';
    container.appendChild(overlay);
    activeOverlay = overlay;

    hideTimer = setTimeout(hideOverlay, SAFETY_TIMEOUT_MS);
    window.addEventListener('blur', onBlur, { once: true });
  }

  // Klicks auf Shop-Pay-/PayPal-/Google-Pay-/Apple-Pay-Buttons sind eigene Custom
  // Elements; ein Klick darauf "retargeted" beim Hochblubbern an die Grenze ihres
  // (teils geschlossenen) Shadow-DOMs auf das jeweilige Host-Element. Ein Listener
  // auf document faengt das zuverlaessig ab, ganz ohne Aenderung am Shopify-Code.
  document.addEventListener('click', (event) => {
    const container = event.target.closest && event.target.closest(CONTAINER_SELECTOR);
    if (container) {
      showOverlay(container);
    }
  }, true);
})();
